import { Pipe, PipeTransform } from '@angular/core';
import { SensorMergeDto } from '@artemis-software/wr-api';
import SensorIntegrationTypeEnum = SensorMergeDto.SensorIntegrationTypeEnum;

@Pipe({
  standalone: false,
  name: 'sensorIntegrationType'
})
export class SensorIntegrationTypePipe implements PipeTransform {
  transform(value: SensorIntegrationTypeEnum | undefined | null): string {
    switch (value) {
      case SensorIntegrationTypeEnum.ReisenbauerSensor:
        return 'RB Sensor';
      case SensorIntegrationTypeEnum.ReisenbauerEnergyMeter:
        return 'RB Zähler';
      case SensorIntegrationTypeEnum.None:
        return 'k.A.';
    }
    return 'k.A.';
  }
}
